import { render, staticRenderFns } from "./CbsViewScalar.vue?vue&type=template&id=3ccc62f0&scoped=true"
import script from "./CbsViewScalar.vue?vue&type=script&lang=js"
export * from "./CbsViewScalar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccc62f0",
  null
  
)

export default component.exports